import { useTranslation } from "react-i18next";

export function useAveragePricesHelpers() {
  const { t } = useTranslation(["averagePrices"]);
  const handlePageTitle = () => {
    const pathname = window.location.pathname.split("/");
    const subpath = pathname[pathname.length - 1];
    return t(`averagePrices:pageTitle.${subpath}`);
  };

  const handleReportTitle = () => {
    const pathname = window.location.pathname.split("/");
    const subpath = pathname[pathname.length - 1];
    return t(`averagePrices:reportTitle.${subpath}`);
  };

  return {
    handlePageTitle,
    handleReportTitle,
  };
}
